import CHOICES from 'CHOICES';
import arrowGrowth from 'assets/icons/arrow-growth.svg';
import crown from 'assets/icons/crown.svg';
import starOutline from 'assets/icons/star-outline.svg';
import bagDollar from 'assets/icons/bag-dollar.svg';
import freePlan from 'assets/icons/typcn_flash-outline.svg';

export const AUTH_TOKEN = 'authToken';

export const ARTICLES = {
  baseUrl: 'https://help.revli.com/en/articles',
  spf: 'https://help.revli.com/en/collections/3625518-dns-records-spf-dkim-dmarc#spf',
  dkim: 'https://help.revli.com/en/collections/3625518-dns-records-spf-dkim-dmarc#dkim',
  dmarc: 'https://help.revli.com/en/collections/3625518-dns-records-spf-dkim-dmarc#dmarc',
  blacklists:
    'https://help.revli.com/en/articles/6604840-what-do-i-need-to-know-about-email-blacklists',
  daysWarming:
    'https://help.revli.com/en/articles/6585286-how-long-should-you-warm-up-your-cold-email-inbox-for',
  domainAge:
    'https://help.revli.com/en/articles/6585284-what-is-domain-age-and-why-is-it-important',
  filterID: 'https://help.revli.com/en/collections/3634647-warm-up-settings#inbox-filter-id',
  warmupSchedule: 'https://help.revli.com/en/collections/3634647-warm-up-settings#warm-up-schedule',
  inboxSignature: 'https://help.revli.com/en/collections/3634647-warm-up-settings#inbox-signature',
  selectTopic: 'https://help.revli.com/en/collections/3634647-warm-up-settings#warm-up-topics',
  timezone: 'https://help.revli.com/en/collections/3634647-warm-up-settings#warm-up-timezone',
  helpCenter: 'https://help.revli.com/',
  termsOfUse: 'https://www.revli.com/terms',
  privacyPolicy: 'https://www.revli.com/privacy-policy',
  fwdApps: 'https://mail.google.com/mail/?authuser=#settings/fwdandpop',
  enable2StepAuthentication:
    'https://myaccount.google.com/signinoptions/two-step-verification?authuser=',
  generateAppPassword: 'https://myaccount.google.com/apppasswords?authuser=',
  helpGuideGoogleOAuth:
    'https://help.revli.com/en/articles/6577250-how-to-connect-your-gmail-google-workspace-inbox-via-google-app-id',
  helpGoogleAppPassword:
    'https://help.revli.com/en/articles/6801930-how-to-connect-your-gmail-google-workspace-inbox-via-app-password',
  helpMS365OAuth:
    'https://help.revli.com/en/articles/6809926-how-to-connect-your-outlook-microsoft-365-inbox',
  deliveribilityGuide: 'https://help.revli.com/en/collections/3789544-email-deliverability-guide'
};

export const MAILBOX_SCORE_TOOLTIP_TEXTS = {
  spf: {
    pass: 'SPF record found.',
    warning: 'Multiple SPF records found.',
    fail: 'No SPF record found.'
  },
  dkim: {
    true: 'DKIM record found.',
    false: 'No DKIM record found.'
  },
  dmarc: {
    pass: 'DMARC record found.',
    fail: 'No DMARC record found.'
  },
  blacklists: {
    true: 'Your domain is not listed on any blacklists.',
    false: 'Your domain is listed on a few blacklists.'
  },
  daysWarming: {
    pass: 'Keep warming to build and maintain your deliverability and open rates.',
    warning: 'Keep warming to improve your deliverability and open rates.',
    fail: 'Keep warming to improve your deliverability and open rates.'
  },
  domainAge: {
    text: `One of the first factors spam filters look at to evaluate the legitimacy of an email address is the domain age.
    \nTherefore, the longer your domain has been active, the better your email deliverability.`
  },
  heading: {
    text: 'Mailbox changes can take up to 24 hours to update.'
  }
};

export const TOOLTIPS = {
  startingBaseline: 'The starting number of emails we will send from day one.',

  increasePerDay: 'The number of additional emails we will send per day until we reach the maximum',

  replyRatePercentage:
    "The percentage of warm-up emails we will automatically reply to each day. This does not impact your prospect's ability to reply to non warm-up emails. These are additional emails added on top of the max email per day rate.",

  maxEmailsPerDay: 'The maximum number of emails we will send each day.'
};

export const defaultTimezone = 'America/New_York';

export const HELP_VIDEOS = {
  connectGoogle: 'https://www.youtube.com/embed/CtkuOcBBKqU',
  connectGoogleSMTP: 'https://www.youtube.com/embed/zBd_Tl-kqkY',
  connectOutlook: 'https://www.youtube.com/embed/7fPJjii5GyM',
  dashboardIntroduction: 'https://www.youtube.com/embed/pIf_yVXFyTM',
  fundingVideo: 'https://www.youtube.com/embed/w6mm7as5-K8'
};

export const domainBlackListDummy = [
  {
    text: 'Passive Spam Block List',
    id: 1,
    value: true
  },
  {
    text: 'Barracuda',
    id: 2,
    value: true
  },
  {
    text: 'URLhaus',
    id: 3,
    value: false
  },
  {
    text: 'PhishTank',
    id: 4,
    value: true
  },
  {
    text: 'NordSpam',
    id: 5,
    value: false
  },
  {
    text: 'IPSpamList',
    id: 6,
    value: true
  },
  {
    text: 'Backscatterer',
    id: 7,
    value: false
  },
  {
    text: 'S5h Blacklist',
    id: 8,
    value: true
  },
  {
    text: 'HoneyDB Blacklist',
    id: 9,
    value: true
  },
  {
    text: 'Myip.ms Blacklist',
    id: 10,
    value: true
  },
  {
    text: 'ViriBack C2 Tracker',
    id: 11,
    value: true
  },
  {
    text: 'AZORult Tracker',
    id: 12,
    value: true
  }
];

export const spamFilterKindChoice = {
  GOOGLE: {
    kind: CHOICES.TestSystemInboxKind.GMAIL,
    label: 'Google'
  },
  OUTLOOK: {
    kind: 2,
    label: 'Outlook'
  },
  [CHOICES.TestSystemInboxKind.GMAIL]: 'Google',
  [CHOICES.TestSystemInboxKind.OFFICE365]: 'Outlook'
};

// Header for the csv download file
export const Headers = [
  { label: 'First Name', key: 'firstName' },
  { label: 'Last Name', key: 'lastName' },
  { label: 'Job Title', key: 'jobTitle' },
  { label: 'Job Departments', key: 'jobDepartments' },
  { label: 'Email', key: 'contactEmail' },
  { label: 'Email Status', key: 'emailStatus' },
  { label: 'Contact LinkedIn', key: 'contactLinkedin' },
  { label: 'Company Name', key: 'companyName' },
  { label: 'Contact City', key: 'contactCity' },
  { label: 'Contact State', key: 'contactState' },
  { label: 'Contact Mobile', key: 'contactMobile' },
  { label: 'Contact Country', key: 'contactCountry' },
  { label: 'Company Headquarters', key: 'companyHeadquarters' },
  { label: '# Employees', key: 'employee' },
  { label: 'Company Website', key: 'companyWebsite' },
  { label: 'Company LinkedIn', key: 'companyLinkedinUrl' },
  { label: 'Company Facebook', key: 'companyFacebook' },
  { label: 'Company Twitter', key: 'companyTwitter' },
  { label: 'Company Phone', key: 'companyPhone' },
  { label: 'Industries', key: 'industries' },
  { label: 'Industry Categories', key: 'industryCategories' },
  { label: 'Company Description', key: 'companyDescription' },
  { label: 'Company Technologies', key: 'companyTechnologies' },
  { label: 'Founded Date', key: 'foundedDate' },
  { label: 'Annual Revenue', key: 'annualRevenue' },
  { label: 'Recent Funding Date', key: 'lastFundingDate' },
  { label: 'Recent Funding Amount(USD)', key: 'latestFundingAmount' },
  { label: 'Last Funding Type', key: 'lastFundingType' },
  { label: 'Funding News', key: 'fundingNews' },
  { label: 'Total Funding Amount(USD)', key: 'totalFundingAmount' },
  { label: 'Funding Status', key: 'fundingStatus' },
  { label: 'Top 5 Investors', key: 'top5Investors' },
  { label: 'Currently Hiring', key: 'currentlyHiring' },
  { label: 'Company Overview', key: 'companyOverview' },
  { label: 'Expansion Strategy', key: 'expansionStrategy' },
  { label: 'Market Opportunities', key: 'marketOpportunities' },
  { label: 'Challenges And Risks', key: 'challengesAndRisks' },
  { label: 'Tech Needs', key: 'techNeeds' },
  { label: 'Infrastructure Needs', key: 'infrastructureNeeds' },
  { label: 'Service Needs', key: 'serviceNeeds' },
  { label: 'Projected Growth', key: 'projectedGrowth' },
  { label: 'Hiring Forecast', key: 'hiringForecast' },
  { label: 'Key Technical Challenges', key: 'keyTechnicalChallenges' }
];

export const HeadersCompanyList = [
  { label: 'Company Name', key: 'companyName' },
  { label: 'Company Headquarters', key: 'companyHeadquarters' },
  { label: '# Employees', key: 'employee' },
  { label: 'Company Website', key: 'companyWebsite' },
  { label: 'Company LinkedIn', key: 'companyLinkedinUrl' },
  { label: 'Company Facebook', key: 'companyFacebook' },
  { label: 'Company Twitter', key: 'companyTwitter' },
  { label: 'Company Phone', key: 'companyPhone' },
  { label: 'Industries', key: 'industries' },
  { label: 'Industry Categories', key: 'industryCategories' },
  { label: 'Company Description', key: 'companyDescription' },
  { label: 'Company Technologies', key: 'companyTechnologies' },
  { label: 'Founded Date', key: 'foundedDate' },
  { label: 'Annual Revenue', key: 'annualRevenue' },
  { label: 'Recent Funding Date', key: 'lastFundingDate' },
  { label: 'Recent Funding Amount(USD)', key: 'latestFundingAmount' },
  { label: 'Last Funding Type', key: 'lastFundingType' },
  { label: 'Funding News', key: 'fundingNews' },
  { label: 'Total Funding Amount(USD)', key: 'totalFundingAmount' },
  { label: 'Funding Status', key: 'fundingStatus' },
  { label: 'Top 5 Investors', key: 'top5Investors' },
  { label: 'Currently Hiring', key: 'currentlyHiring' },
  { label: 'Company Overview', key: 'companyOverview' },
  { label: 'Expansion Strategy', key: 'expansionStrategy' },
  { label: 'Market Opportunities', key: 'marketOpportunities' },
  { label: 'Challenges And Risks', key: 'challengesAndRisks' },
  { label: 'Tech Needs', key: 'techNeeds' },
  { label: 'Infrastructure Needs', key: 'infrastructureNeeds' },
  { label: 'Service Needs', key: 'serviceNeeds' },
  { label: 'Projected Growth', key: 'projectedGrowth' },
  { label: 'Hiring Forecast', key: 'hiringForecast' },
  { label: 'Key Technical Challenges', key: 'keyTechnicalChallenges' }
];

export const HeaderInvestorContactList = [
  { label: 'Upload Date', key: 'uploadedDate' },
  { label: 'First Name', key: 'firstName' },
  { label: 'Last Name', key: 'lastName' },
  { label: 'Company Name', key: 'firmName' },
  { label: 'Job Title', key: 'jobTitle' },
  { label: 'Job Department', key: 'jobDepartment' },
  { label: 'Contact Mobile', key: 'contactMobile' },
  { label: 'Contact Email', key: 'email' },
  { label: 'Email Status', key: 'emailStatus' },
  { label: 'Person Linkedin Url', key: 'linkedinUrl' },
  { label: 'Contact City', key: 'contactCity' },
  { label: 'Contact State', key: 'contactState' },
  { label: 'Contact Country', key: 'contactCountry' },
  { label: 'Company City', key: 'companyCity' },
  { label: 'Company State', key: 'companyState' },
  { label: 'Company Country', key: 'companyCountry' },
  { label: '# Employees', key: 'employee' },
  { label: 'Website', key: 'firmWebsite' },
  { label: 'Company Linkedin Url', key: 'firmLinkedin' },
  { label: 'Facebook Url', key: 'facebookUrl' },
  { label: 'Twitter Url', key: 'twitterUrl' },
  { label: 'Company Phone', key: 'companyPhone' },
  { label: 'Company Description', key: 'companyDescription' },
  { label: 'Founded Date', key: 'foundedDate' },
  { label: 'Startups Invested This Week', key: 'startupsInvestedThisWeek' },
  {label: 'Historical Investment', key: 'historicalInvestmentData' },
  { label: 'Firm Type', key: 'firmType' },
  { label: 'Stage Focus', key: 'stageFocus' },
  { label: 'Check Size', key: 'checkSize' },
  { label: 'Portfolio Size', key: 'portfolioSize' },
  { label: 'Industry Focus', key: 'industryFocus' },
  { label: 'Geography Focus', key: 'geographicFocus' },
  { label: 'Firm Overview', key: 'firmOverview' },
  { label: 'Investor Thesis', key: 'investorThesis' },
  { label: 'Portfolio Highlights', key: 'portfolioHighlights' },
  { label: 'Co-Investor Network', key: 'coInvestorNetwork' },
];
export const HeaderInvestorCompanyList = [
  { label: 'Upload Date', key: 'uploadedDate' },
  { label: 'Company Name', key: 'firmName' },
  { label: 'Company City', key: 'companyCity' },
  { label: 'Company State', key: 'companyState' },
  { label: 'Company Country', key: 'companyCountry' },
  { label: '# Employees', key: 'employee' },
  { label: 'Website', key: 'firmWebsite' },
  { label: 'Company Linkedin Url', key: 'firmLinkedin' },
  { label: 'Facebook Url', key: 'facebookUrl' },
  { label: 'Twitter Url', key: 'twitterUrl' },
  { label: 'Company Phone', key: 'companyPhone' },
  { label: 'Company Description', key: 'companyDescription' },
  { label: 'Founded Date', key: 'foundedDate' },
  { label: 'Startups Invested This Week', key: 'startupsInvestedThisWeek' },
  { label:'Historical Investment',key:'historicalInvestmentData'},
  { label: 'Firm Type', key: 'firmType' },
  { label: 'Stage Focus', key: 'stageFocus' },
  { label: 'Check Size', key: 'checkSize' },
  { label: 'Portfolio Size', key: 'portfolioSize' },
  { label: 'Industry Focus', key: 'industryFocus' },
  { label: 'Geography Focus', key: 'geographicFocus' },
  { label: 'Firm Overview', key: 'firmOverview' },
  { label: 'Investor Thesis', key: 'investorThesis' },
  { label: 'Portfolio Highlights', key: 'portfolioHighlights' },
  { label: 'Co-Investor Network', key: 'coInvestorNetwork' }
];

// Mapping of plan keys to human-readable names
export const VISIBILITY_RULES_VALUE = {
  free: 'Free Trial',
  growth: 'Growth',
  pro: 'Pro Plan',
  investor: 'Investor',
  allaccess: 'All Access'
};

// Rules for each plan
export const VISIBILITY_RULES = {
  free: {
    // General popup should include the current plan
    general_popup: {
      includeCurrent: true,
      onlyAnnual: false,
      plans: ['Free Trial', 'Growth', 'Pro Plan', 'Investor', 'All Access']
    },

    // Export CSV attempt
    export_csv_startup: {
      includeCurrent: false,
      onlyAnnual: false,
      plans: ['Pro Plan', 'All Access']
    },

    export_csv_investor: {
      includeCurrent: true,
      onlyAnnual: false,
      plans: ['Investor', 'All Access']
    },

    // Historical view list
    historical_view_list: {
      includeCurrent: false,
      onlyAnnual: false,
      plans: ['Pro Plan', 'All Access']
    },

    // Accessing startup data / row
    access_startup_row: {
      includeCurrent: false,
      onlyAnnual: false,
      plans: ['Growth', 'Pro Plan', 'All Access']
    },

    // Accessing investor data / row
    access_investor_row: {
      includeCurrent: false,
      onlyAnnual: false,
      plans: ['Investor', 'All Access']
    },

    // Funding Insight
    export_csv_startup_funding: {
      includeCurrent: false,
      onlyAnnual: true,
      plans: ['Pro Plan', 'All Access']
    },

    export_csv_investor_funding: {
      includeCurrent: true,
      onlyAnnual: true,
      plans: ['Investor', 'All Access']
    },

    access_startup_row_funding: {
      includeCurrent: false,
      onlyAnnual: false,
      plans: ['Pro Plan', 'All Access']
    },

    access_investor_row_funding: {
      includeCurrent: false,
      onlyAnnual: false,
      plans: ['Investor', 'All Access']
    },

    upgrade_restrictions: [],
    upgrade_monthly_restrictions: []
  },

  growth: {
    general_popup: {
      includeCurrent: true,
      onlyAnnual: false,
      plans: ['Free Trial', 'Growth', 'Pro Plan', 'Investor', 'All Access']
    },
    // Export CSV attempt
    export_csv_startup: {
      includeCurrent: true,
      onlyAnnual: false,
      plans: ['Pro Plan', 'All Access']
    },

    export_csv_investor: { includeCurrent: true, onlyAnnual: false, plans: ['All Access'] },

    // Historical view list
    historical_view_list: { includeCurrent: false, onlyAnnual: false, plans: ['All Access'] },

    // Accessing startup data / row
    access_startup_row: {
      includeCurrent: false,
      onlyAnnual: false,
      plans: ['All Access']
    },

    // Accessing investor data / row
    access_investor_row: { includeCurrent: false, onlyAnnual: false, plans: ['All Access'] },

    // Funding Insight
    export_csv_startup_funding: {
      includeCurrent: true,
      onlyAnnual: true,
      plans: ['Pro Plan', 'All Access']
    },

    export_csv_investor_funding: {
      includeCurrent: true,
      onlyAnnual: true,
      plans: ['All Access']
    },

    access_startup_row_funding: {
      includeCurrent: false,
      onlyAnnual: false,
      plans: ['Pro Plan', 'All Access']
    },

    access_investor_row_funding: {
      includeCurrent: false,
      onlyAnnual: false,
      plans: ['All Access']
    },
    upgrade_restrictions: ['Investor'],
    upgrade_monthly_restrictions: ['Pro Plan', 'All Access']
    // upgrade_tooltip:
    //   'Switching to Investor would remove startup data. Upgrade to All Access for both.',
  },

  pro: {
    // Export CSV attempt
    general_popup: {
      includeCurrent: true,
      onlyAnnual: false,
      plans: ['Free Trial', 'Growth', 'Pro Plan', 'Investor', 'All Access']
    },
    export_csv_startup: {
      includeCurrent: true,
      onlyAnnual: false,
      plans: ['Pro Plan', 'All Access']
    },

    export_csv_investor: { includeCurrent: true, onlyAnnual: false, plans: ['All Access'] },

    // Accessing investor data / row
    access_investor_row: { includeCurrent: false, onlyAnnual: false, plans: ['All Access'] },

    // Funding Insight
    export_csv_startup_funding: {
      includeCurrent: true,
      onlyAnnual: true,
      plans: ['Pro Plan', 'All Access']
    },

    export_csv_investor_funding: {
      includeCurrent: true,
      onlyAnnual: true,
      plans: ['All Access']
    },

    access_investor_row_funding: {
      includeCurrent: false,
      onlyAnnual: false,
      plans: ['All Access']
    },

    upgrade_restrictions: ['Investor'],
    upgrade_monthly_restrictions: ['All Access']
    // upgrade_tooltip:
    //   'Switching to Investor would remove startup data. Upgrade to All Access for both.'
  },

  investor: {
    general_popup: {
      includeCurrent: true,
      onlyAnnual: false,
      plans: ['Free Trial', 'Growth', 'Pro Plan', 'Investor', 'All Access']
    },
    // Export CSV attempt
    export_csv_startup: { includeCurrent: true, onlyAnnual: false, plans: ['All Access'] },
    export_csv_investor: { includeCurrent: true, onlyAnnual: false, plans: ['All Access'] },
    // Historical view list
    historical_view_list: { includeCurrent: false, onlyAnnual: false, plans: ['All Access'] },

    // Accessing startup data / row
    access_startup_row: { includeCurrent: false, onlyAnnual: false, plans: ['All Access'] },

    // Funding Insight
    export_csv_startup_funding: {
      includeCurrent: true,
      onlyAnnual: true,
      plans: ['All Access']
    },

    export_csv_investor_funding: {
      includeCurrent: true,
      onlyAnnual: true,
      plans: ['All Access']
    },

    access_startup_row_funding: {
      includeCurrent: false,
      onlyAnnual: false,
      plans: ['All Access']
    },

    upgrade_restrictions: ['Growth', 'Pro Plan'],
    upgrade_monthly_restrictions: ['All Access']
    // upgrade_tooltip_growth:
    //   'Switching to Growth would remove Investor data. Upgrade to All Access for both.',
    // upgrade_tooltip_pro:
    //   'Switching to Pro would remove Investor data. Upgrade to All Access for both.'
  },

  allaccess: {
    general_popup: {
      includeCurrent: true,
      onlyAnnual: false,
      plans: ['Free Trial', 'Growth', 'Pro Plan', 'Investor', 'All Access']
    },
    // Export CSV attempt
    export_csv_startup: { includeCurrent: true, onlyAnnual: false, plans: ['All Access'] },
    export_csv_investor: { includeCurrent: true, onlyAnnual: false, plans: ['All Access'] },

    // Funding Insight
    export_csv_startup_funding: {
      includeCurrent: true,
      onlyAnnual: true,
      plans: ['All Access']
    },

    export_csv_investor_funding: {
      includeCurrent: true,
      onlyAnnual: true,
      plans: ['All Access']
    },

    upgrade_restrictions: [],
    upgrade_monthly_restrictions: []
  }
};

export const restrictionMessages = {
  Investor: 'Switching to Investor would remove startup data. Upgrade to All Access for both.',
  Growth: 'Switching to Growth would remove Investor data. Upgrade to All Access for both.',
  'Pro Plan': 'Switching to Pro would remove Investor data. Upgrade to All Access for both.'
};

export const restrictionMessagesAnnualPlan = {
  'Growth': 'You’re on an annual plan. To downgrade to Growth, please choose the annual option.',
  'Pro Plan': 'You’re on an annual plan. To upgrade to Pro, please choose the annual option.',
  'All Access': 'You’re on an annual plan. To upgrade to All Access, please choose the annual option.',
}

export const planIcons = {
  Growth: arrowGrowth,
  'Pro Plan': crown,
  'All Access': starOutline,
  Investor: bagDollar,
  'Free Trial': freePlan
};
export const planText = {
  Growth: 'Weekly reports + filters for fast, verified outreach',
  'Pro Plan': 'Includes mobile, hiring data, CSV export, and all filters',
  'All Access': 'Startup + investor data with full filters and priority support',
  Investor: 'Access investor firm data, contact info, and past startup investments'
};
export const freeTrialPlan = {
  name: 'Free Trial',
  kind: 0,
  position: -1,
  prices: [
    { amount: null, onBasis: 1 },
    { amount: null, onBasis: 2 }
  ],
  stripePlanId: null,
  isActive: true,
  extraFilters: false,
  isCsvExport: false,
  unlockRecords: false,
  unlockSpclFields: false
};
